var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const ajaxSend = (params) => __awaiter(void 0, void 0, void 0, function* () {
    const fetchResp = yield fetch(params.url, {
        method: 'POST',
        body: params.formData && params.formData
    });
    if (!fetchResp.ok) {
        throw new Error(`Ошибка по адресу ${params.url}, статус ошибки ${fetchResp.status}`);
    }
    if (params.responseFormat == 'json') {
        return yield fetchResp.json();
    }
    else {
        return yield fetchResp.text();
    }
});
export default ajaxSend;
